import defaultView from "./default.vue";
import tabbar from "./tabbar.vue";
export default {
  defaultView,
  tabbar
};
